import { Controller } from "@hotwired/stimulus"

export default class CurrentAccountMonitorController extends Controller {
  connect() {
    if (current.account.id !== undefined) {
      localStorage.setItem("current-account-id", current.account.id)
    } else {
      localStorage.removeItem("current-account-id")
    }

    this.#redirectIfAccountChanged()

    this.boundHandleStorageChange = this.handleStorageChange.bind(this)
    window.addEventListener("storage", this.boundHandleStorageChange)
  }

  disconnect() {
    window.removeEventListener("storage", this.boundHandleStorageChange)
  }

  handleStorageChange(event) {
    if (event.key === "current-account-id") {
      this.#redirectIfAccountChanged()
    }
  }

  #redirectIfAccountChanged() {
    const currentAccount = current.account.id || null
    const storedAccount = localStorage.getItem("current-account-id")

    if ((currentAccount || storedAccount) && currentAccount !== storedAccount) {
      window.location.href = "/"
    }
  }
}
